import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { get } from 'lodash';

dayjs.extend(utc);

const FORMAT_MAP = {
    cn: {
        date: 'YYYY-MM-DD',
        time: 'YYYY-MM-DD HH:mm',
        chartTime: 'YYYYMMDD'
    },
    en: {
        date: 'DD MMM YYYY',
        time: 'DD MMM YYYY hh:mm a',
        chartTime: 'DD MMM YYYY',
    },
    jp: {
        date: 'YYYY.MM.DD',
        time: 'YYYY.MM.DD HH:mm',
        chartTime: 'YYYYMMDD',
    },
    tw: {
        date: 'YYYY-MM-DD',
        time: 'YYYY-MM-DD HH:mm',
        chartTime: 'YYYYMMDD'
    }
};

const i18n = {
    cn: {
        today: '今天',
        yesterday: '昨天',
        ago: '${day}天前'
    },
    en: {
        today: 'Today',
        yesterday: 'Yesterday',
        ago: '${day} days ago'
    },
    jp: {
        today: '今日',
        yesterday: '昨日',
        ago: '${day}日前'
    },
    tw: {
        today: '今天',
        yesterday: '昨天',
        ago: '${day}天前'
    }
};

export function formatDate({ date, utcOffset, currentLang = 'cn', type = 'date', forceFormat }) {
    const format = forceFormat || get(FORMAT_MAP, `${currentLang}.${type}`, FORMAT_MAP.cn.date);
    let formatDate = '';
    if (!utcOffset) {
        formatDate = dayjs(date).format(format);
    } else {
        const offsetDate = dayjs(dayjs(date).format(format)).utcOffset(utcOffset);
        formatDate = dayjs(offsetDate).format(format);
    }
    return formatDate;
}

export function formatDateToLocal({ date, currentLang = 'cn' }) {
    const oneDayTimes = 24 * 3600 * 1000;
    const todayStart = new Date().setHours(0, 0, 0, 0);
    const target = new Date(date).setHours(0, 0, 0, 0);
    if (target >= todayStart) {
        return i18n[currentLang].today;
    }
    const diff = Math.floor((todayStart - target) / oneDayTimes);
    if (diff <= 1) {
        return i18n[currentLang].yesterday;
    }
    if (diff > 7) {
        return formatDate({ date, currentLang });
    }
    return i18n[currentLang].ago.replace('${day}', diff);
}
